module.exports = __webpack_public_path__ + "img/w3_circle_down_white.c7952a55.c7952a55.png";